var d = (t) => {
  throw TypeError(t);
}, r = (t, e, s) => e.has(t) || d("Cannot " + s), v = (t, e, s) => (r(t, e, "read from private field"), s ? s.call(t) : e.get(t)), n = (t, e, s) => e.has(t) ? d("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(t) : e.set(t, s), b = (t, e, s, o) => (r(t, e, "write to private field"), e.set(t, s), s), h = (t, e, s) => (r(t, e, "access private method"), s);
const p = ["id"], c = [...p];
var a, i, l, u;
class m {
  constructor(e, s) {
    n(this, i), n(this, a), this.attributes = /* @__PURE__ */ new Map(), (this.host = e).addController(this), b(this, a, s);
  }
  hostConnected() {
    h(this, i, l).call(this), h(this, i, u).call(this);
  }
}
a = /* @__PURE__ */ new WeakMap(), i = /* @__PURE__ */ new WeakSet(), l = function() {
  var t, e;
  if (this.host instanceof HTMLElement) {
    for (const s of c)
      this.attributes.set(
        s,
        (e = this.host.getAttribute(s)) != null ? e : (t = v(this, a)) == null ? void 0 : t[s]
      );
    this.host.requestUpdate();
  }
}, u = function() {
  const t = new MutationObserver(
    (e, s) => {
      for (const { attributeName: o, target: f } of e)
        o === "id" && this.attributes.set("id", f.id);
      this.host.requestUpdate();
    }
  );
  this.host instanceof HTMLElement && t.observe(this.host, {
    attributes: !0,
    attributeFilter: c
  });
};
export {
  m as A
};
